/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2024 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
"use client";
import { ExcelExporter as o, Workbook as a } from "@progress/kendo-ooxml";
import { toExporterColumns as c } from "./ExporterColumns.mjs";
const n = (e) => Math.max(...e.map((r) => r.level)) + 1, i = (e) => {
  const r = c(e.columns), t = new o({
    columns: r,
    data: e.data,
    filterable: e.filterable,
    groups: e.group,
    paddingCellOptions: e.paddingCellOptions,
    headerPaddingCellOptions: e.headerPaddingCellOptions,
    hierarchy: e.hierarchy ? { depth: n(e.data), itemLevel: (l) => l.level } : null,
    collapsible: e.collapsible
  }).workbook();
  return t.creator = e.creator, t.date = e.date, t.rtl = e.dir === "rtl", t;
}, p = (e) => new a(e).toDataURL(), u = (e) => e && e.sheets;
export {
  u as isWorkbookOptions,
  p as toDataURL,
  i as workbookOptions
};
